import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import * as SecureLS from "secure-ls";
import { GlobalService } from '../../services/global.service';
import { StorageService } from '../../services/storage.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-video-bookmark',
  templateUrl: './video-bookmark.component.html',
  styleUrls: ['./video-bookmark.component.css']
})
export class VideoBookmarkComponent implements OnInit, OnChanges {
  private ls = new SecureLS({ encodingType: "aes" });
  @Input() showBookmarkList;
  @Input() mediaPlayerEvent;
  @Input() isOnlyView;
  bookmarkForm: FormGroup;
  onlyView = false;
  bookmarkTopicList = [];
  showDDMenu = false;
  seconds = true;
  showSaveBookmarkBtn = false;
  bookmarkTopicDataForEdit: Object;
  bookmarkcount: number;
  constructor(
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public router: ActivatedRoute,
    public globalService: GlobalService,
    private storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.onlyView = this.storageService.getRole() == 4 || this.storageService.getRole() == 3 || this.storageService.getRole() == 2;
    this.bookmarkForm = this.fb.group({
      topic: [{ value: "", disabled: false }, [Validators.required]],
      duration: [{ value: "", disabled: false }, [Validators.required]],
    });
    this.getBookmarkTopics();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['showBookmarkList']?.currentValue) {
      this.getBookmarkTopics();
    } else if(!changes['showBookmarkList']?.currentValue) {
      this.bookmarkForm?.reset();
    }
  }

  async getBookmarkTopics() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
    };

    let bookmarkTopic = await this.globalService.get("videotopic/list", filter,true);
    if (bookmarkTopic["status"] == 200) {
      this.bookmarkTopicList = this.resetDDMenu(
        bookmarkTopic["content"]["rows"]
      );
      this.bookmarkcount = this.bookmarkTopicList.length
      this.spinner.hide();
    }
     else {
      this.bookmarkcount = 0;
      this.spinner.hide();
    }
  }

  resetDDMenu(bookmarkTopicList) {
    return bookmarkTopicList?.map((list) => {
      if (list.hasOwnProperty("isDDMenuShow")) {
        list.isDDMenuShow = false;
      } else {
        list = { ...list, isDDMenuShow: false };
      }
      return list;
    });
  }

  

  async onCreateBookmark() {
    if(this.bookmarkForm.invalid) {
      return;
    }
    this.spinner.show();
    let start_second = this.bookmarkForm.controls["duration"].value.second;
    let start_min = this.bookmarkForm.controls["duration"].value.minute * 60;
    let start_hrs = this.bookmarkForm.controls["duration"].value.hour * 60 * 60;

    let totalBookmarkTopic = start_second + start_min + start_hrs;
    let requestPayload = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      topic: this.bookmarkForm.controls["topic"].value,
      duration: totalBookmarkTopic,
    };

    let createdBookmarkTopic = await this.globalService.create(
      "videotopic/create",
      requestPayload
    );
    if (createdBookmarkTopic["status"] == 200) {
      Swal.fire("Success!", createdBookmarkTopic["message"], "success");
      this.bookmarkForm.reset();
      this.getBookmarkTopics();
    } else {
      this.spinner.hide();
    }
  }

  async onSaveBookmark() {
    if(this.bookmarkForm.invalid) {
      return;
    }
    this.spinner.show();
    let start_second = this.bookmarkForm.controls["duration"].value.second;
    let start_min = this.bookmarkForm.controls["duration"].value.minute * 60;
    let start_hrs = this.bookmarkForm.controls["duration"].value.hour * 60 * 60;

    let totalBookmarkTopicTime = start_second + start_min + start_hrs;
    let requestPayload = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      topic: this.bookmarkForm.controls["topic"].value,
      duration: totalBookmarkTopicTime,
      id: this.bookmarkTopicDataForEdit["content"]["rows"][0]["id"]
    };

    let savedBookmarkTopic = await this.globalService.update(
      "videotopic/update",
      requestPayload
    );
    if (savedBookmarkTopic["status"] == 200) {
      Swal.fire("Success!", savedBookmarkTopic["message"], "success");
      this.onResetBookmark();
      this.getBookmarkTopics();
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }

  onMoveToBookmark(bookmarkTopic) {
    this.mediaPlayerEvent.seekTime(bookmarkTopic?.duration, false);
    this.mediaPlayerEvent.getDefaultMedia().currentTime =
      bookmarkTopic?.duration;
    this.mediaPlayerEvent.play();
  }

  onResetBookmark() {
    this.bookmarkForm.reset();
    this.showSaveBookmarkBtn = false;
  }
  addZeroPrefix(n): string {
    return (`${n}`.length == 1) ? `0${n}` : `${n}`
  }
  getReadableTime(duration, isNeedObj?) {
    let start;
    let startObj = {};
    if (duration < 3600) {
      var a = Math.floor(duration / 60); //minutes
      var b = duration % 60; //seconds

      start =  this.addZeroPrefix(a) + ":" + this.addZeroPrefix(b);
      startObj['hour'] = 0;
      startObj['minute'] = a;
      startObj['second'] = b;
    } else {
      var a = Math.floor(duration / 3600); //hours
      var x = duration % 3600;
      var b = Math.floor(x / 60); //minutes
      var c = duration % 60; //seconds

      start = this.addZeroPrefix(a) + ":" + this.addZeroPrefix(b) + ":" + this.addZeroPrefix(c);
      startObj['hour'] = a;
      startObj['minute'] = b;
      startObj['second'] = c;
    }
    return (isNeedObj) ? startObj : start;
  }

  onEditBookmarkTopic(bookmarkTopic) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          class_room_video_details_id: this.router.snapshot.queryParams.key,
          id: bookmarkTopic.id,
          topic: bookmarkTopic.topic,
          role_id: this.storageService.getRole(),
        };

        this.bookmarkTopicDataForEdit = await this.globalService.get(
          "videotopic/list",
          filter,true
        );
        if (this.bookmarkTopicDataForEdit["status"] == 200) {
          this.showSaveBookmarkBtn = true;
          this.bookmarkForm.controls["topic"].patchValue(
            this.bookmarkTopicDataForEdit["content"]["rows"][0]["topic"]
          );
          this.bookmarkForm.controls["duration"].patchValue(
            this.getReadableTime(this.bookmarkTopicDataForEdit["content"]["rows"][0]["duration"], true)
          );
          this.resetDDMenu(this.bookmarkTopicList);
          this.spinner.hide();
        } else {
          this.spinner.hide();
        }
      }
    });
  }

  async onDeleteBookmarkTopic(bookmarkTopic) {
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          class_room_video_details_id: this.router.snapshot.queryParams.key,
          id: bookmarkTopic.id,
          role_id: this.storageService.getRole(),
        };
        let deleteBookmarkTopic = await this.globalService.delete(
          "videotopic/delete",
          filter
        );
        if (deleteBookmarkTopic["status"] === 200) {
          Swal.fire("Success!", deleteBookmarkTopic["message"], "success");
        } else {
          this.spinner.hide();
        }
        await this.getBookmarkTopics();
      }
    });
  }

  onClickThreeDotMenu(bookmarkTopic) {
    this.bookmarkTopicList = this.bookmarkTopicList?.map((list) => {
      if (bookmarkTopic.id == list.id) {
        list.isDDMenuShow = !list.isDDMenuShow;
      } else {
        list.isDDMenuShow = false;
      }
      return list;
    });
  }

}
